import React from "react";

function Navbar() {
  return (
    <div className="navbar">
      <a href="#home">BOOK MATCHING WEB APP</a>
    </div>
  );
}

export default Navbar;
